<template>
    <div>
        <headline-container headline="Invoice Orders" :breadcrumbs="breadcrumbs"></headline-container>

        <loading-container v-if="loading"></loading-container>

        <div v-else class="container">
            <form @submit.prevent="submit">
                <div class="row">
                    <div class="col-xs-6">
                        <help-text>
                            <h3>
                                Invoice Orders
                            </h3>

                            <p>
                                Select the ads to invoice.
                            </p>
                        </help-text>
                    </div>

                    <div class="col-xs-18">
                        <div class="panel panel-default">
                            <div class="panel-body">
                                <form @submit.prevent="filter">
                                    <div class="row">
                                        <div class="col-md-20">
                                            <div class="form-group">
                                                <date-widget
                                                        v-model="adMonth"
                                                        class="form-control input-sm"
                                                        :parameters="{viewMode: 'years'}"
                                                        format="MM.YYYY"
                                                        original-format="YYYY-MM"
                                                ></date-widget>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <button type="submit" class="btn btn-default btn-block btn-black btn-sm">
                                                <i class="fa fa-filter"></i> Filter
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <buyable-select
                                        v-model="orderPayments.ads"
                                        :orders="orders.data"
                                        :month="selectedAdMonth"
                                ></buyable-select>
                            </div>
                        </div>
                    </div>
                </div>

                <hr class="panel-separator">

                <div class="row">
                    <div class="col-xs-6">
                        <help-text>
                            <h3>
                                Set Date
                            </h3>

                            <p>
                                Set the date of the invoices.
                            </p>
                        </help-text>
                    </div>

                    <div class="col-xs-18">
                        <div class="panel panel-default">
                            <div class="panel-body">
                                <date-form-group
                                        v-model="orderPayments.date"
                                        name="date"
                                        label="Date"
                                        help-text="The date of the invoices."
                                        :error="getError('date')"
                                        format="DD.MM.YYYY"
                                ></date-form-group>
                            </div>
                        </div>
                    </div>
                </div>

                <hr class="panel-separator">

                <div class="row">
                    <div class="col-xs-offset-6 col-xs-18">
                        <button type="submit" class="btn btn-black" style="margin-bottom: 22px" :disabled="submitting">
                            <span v-if="submitting">
                                <i class="fa fa-spinner fa-spin fa-fw"></i> Save
                            </span>

                            <span v-else>
                                <i class="fa fa-save"></i> Save
                            </span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import moment from 'moment'
    import notify from '@/notify'
    import BuyableSelect from '@/components/BuyableSelect'
    import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
    import DateWidget from '@/vendor/forms/FormGroups/Widgets/Date'
    import Errors from '@/mixins/Errors'
    import HeadlineContainer from '@/components/Layout/HeadlineContainer'
    import HelpText from '@/components/HelpText'
    import Load from '@/mixins/Load'
    import LoadingContainer from '@/components/Layout/LoadingContainer'

    export default {
        components: {BuyableSelect, DateFormGroup, DateWidget, HeadlineContainer, HelpText, LoadingContainer},

        mixins: [Errors, Load],

        data() {
            return {
                orderPayments: {
                    date: moment().format('YYYY-MM-DD'),
                    ads: []
                },
                orders: {},
                adMonth: moment().format('YYYY-MM'),
                selectedAdMonth: moment().format('YYYY-MM'),
                submitting: false
            }
        },

        mounted() {
            this.load({orders: '/api/v1/orders?status=unpaid&ad_month=' + this.adMonth}, () => {
                this.orders.data.map(order => {
                    order.ads.sort((a, b) => a.sort_key > b.sort_key ? 1 : -1)

                    return order
                })
            })
        },

        computed: {
            breadcrumbs() {
                return [
                    {text: 'Orders', url: '/orders'},
                    {text: 'Invoice Orders'}
                ]
            }
        },

        methods: {
            filter() {
                this.selectedAdMonth = this.adMonth

                this.orderPayments.ads = []

                this.load({orders: '/api/v1/orders?ad_month=' + this.adMonth})
            },

            submit() {
                this.submitting = true

                http.post('/api/v1/order-payments', this.orderPayments)
                    .then(() => {
                        notify.success('The order payments were saved')

                        this.$router.push('/orders')
                    })
                    .catch(error => {
                        this.submitting = false

                        this.catchValidationErrors(error)
                    })
            }
        }
    }
</script>
